import {
  LayoutDashboard,
  CalendarDays,
  Calendar,
  Users,
  GraduationCap,
  Settings,
  Calculator,
  MonitorPlay,
  Video,
  Award,
  Music,
  Trophy,
  Mic,
  Home,
  Globe,
  Mail,
  Bell,
  Clock,
  Megaphone,
  Theater,
} from "lucide-react";

export const navConfig = {
  admin: {
    title: "Dance Digital",
    sections: [
      {
        type: "item",
        to: "/admin/dashboard",
        icon: LayoutDashboard,
        label: "Dashboard",
      },
      {
        type: "section",
        title: "MANAGEMENT",
        defaultOpen: true,
        items: [
          { to: "/admin/events", icon: CalendarDays, label: "Events" },
          { to: "/admin/studios", icon: Users, label: "Studios" },
          { to: "/admin/competition", icon: Trophy, label: "Competition" },
          { to: "/admin/stages", icon: Theater, label: "Stages" },
          {
            to: "/admin/scholarships",
            icon: Award,
            label: "Scholarships",
            badge: "3",
          },
          { to: "/admin/marketing", icon: Megaphone, label: "Marketing" },
        ],
      },
      {
        type: "section",
        title: "TOOLS",
        defaultOpen: false,
        items: [
          { to: "/competition/portal", icon: Home, label: "Competition Portal" },
          { to: "/tabulator", icon: Calculator, label: "Tabulator" },
          {
            to: "/judge-station/1",
            icon: MonitorPlay,
            label: "Judge Station",
          },

          { 
            to: "/emcee/current",
            icon: Mic, 
            label: "Emcee",
            isNew: true 
          },
        ],
      },
      {
        type: "item",
        to: "/admin/settings",
        icon: Settings,
        label: "Settings",
      },
    ],
  },
  "limited-admin": {
    title: "Dance Digital",
    sections: [
      {
        type: "item",
        to: "/admin/limited-dashboard",
        icon: LayoutDashboard,
        label: "Dashboard",
      },
      {
        type: "section",
        title: "MANAGEMENT",
        defaultOpen: true,
        items: [
          { to: "/admin/competition", icon: Trophy, label: "Competition" },
          { to: "/admin/stages", icon: Theater, label: "Stages" },
        ],
      },
      {
        type: "section",
        title: "TOOLS",
        defaultOpen: false,
        items: [
          { to: "/competition/portal", icon: Home, label: "Competition Portal" },
          { to: "/tabulator", icon: Calculator, label: "Tabulator" },
          {
            to: "/judge-station/1",
            icon: MonitorPlay,
            label: "Judge Station",
          },

          { 
            to: "/emcee/current",
            icon: Mic, 
            label: "Emcee",
            isNew: true 
          },
        ],
      },
      {
        type: "item",
        to: "/admin/settings",
        icon: Settings,
        label: "Settings",
      },
    ],
  },
  user: {
    title: "Studio Portal",
    sections: [
      {
        type: "section",
        title: "MAIN",
        defaultOpen: true,
        items: [
          {
            to: "/user/dashboard",
            icon: LayoutDashboard,
            label: "Dashboard",
          },
          { to: "/user/events", icon: Calendar, label: "Events", badge: "2" },
          { to: "/user/critiques", icon: Video, label: "Critiques" },
        ],
      },
      {
        type: "section",
        title: "MANAGEMENT",
        defaultOpen: true,
        items: [
          { to: "/user/studio", icon: Users, label: "Studio" },
          { to: "/user/routines", icon: Music, label: "Routines" },
        ],
      },
      {
        type: "item",
        to: "/user/settings",
        icon: Settings,
        label: "Settings",
      },
    ],
  },
}; 